import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";

function Decide() {
  const mouth1 = useRef();
  const mouth2 = useRef();
  const leftHand1 = useRef();
  const leftHand2 = useRef();
  const pupil1 = useRef();
  const pupil2 = useRef();
  const rightHand1 = useRef();
  const rightHand2 = useRef();
  const launcher = useRef();
  const aborter = useRef();

  useEffect(() => {
    gsap.to(launcher.current, {
      scale: "1.2",
      repeat: "-1",
      duration: "1.5",
      yoyoEase: true,
      yoyo: true,
    });
    gsap.to(aborter.current, {
      scale: "1.2",
      repeat: "-1",
      duration: "1.5",
      yoyoEase: true,
      yoyo: true,
    });
    gsap.to(pupil1.current, {
      rotation: "45",
      repeat: "-1",
      duration: "3",
      ease: "bounce",
      yoyoEase: true,
      yoyo: true,
    });
    gsap.to(pupil2.current, {
      rotation: "-45",
      repeat: "-1",
      duration: "3",
      ease: "bounce",
      yoyoEase: true,
      yoyo: true,
    });
    gsap.to(rightHand1.current, {
      y: "10",
      yoyo: true,
      duration: "1.3",
      yoyoEase: "true",
      ease: "power1.ease",
      repeat: "-1",
    });
    gsap.to(rightHand2.current, {
      y: "10",
      yoyo: true,
      duration: "1.3",
      yoyoEase: "true",
      ease: "power1.ease",
      repeat: "-1",
    });
    gsap.to(leftHand1.current, {
      y: "10",
      yoyo: true,
      duration: "1.3",
      yoyoEase: "true",
      ease: "power1.ease",
      repeat: "-1",
    });
    gsap.to(leftHand2.current, {
      y: "10",
      yoyo: true,
      duration: "1.3",
      yoyoEase: "true",
      ease: "power1.ease",
      repeat: "-1",
    });
    gsap.to(mouth1.current, {
      scale: "1.3",
      repeat: "-1",
      duration: "1.5",
      yoyo: true,
    });
    gsap.to(mouth2.current, {
      scale: "1.3",
      repeat: "-1",
      duration: "1.5",
      yoyo: true,
    });
  });

  return (
    <>
      <svg
        width="300"
        height="300"
        viewBox="0 0 650 227"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="decideSvg"
      >
        <g id="decide" clipPath="url(#clip0_0_1)">
          <path
            id="Path 680"
            d="M87.921 -7.62939e-06C86.9165 -7.62939e-06 85.9531 0.399074 85.2427 1.1094C84.5324 1.81972 84.1334 2.7831 84.1334 3.78765C84.1334 4.7922 84.5324 5.75561 85.2427 6.46593C85.9531 7.17626 86.9165 7.57531 87.921 7.57531H164.755C165.76 7.57531 166.723 7.17626 167.434 6.46593C168.144 5.75561 168.543 4.7922 168.543 3.78765C168.543 2.7831 168.144 1.81972 167.434 1.1094C166.723 0.399074 165.76 -7.62939e-06 164.755 -7.62939e-06H87.921Z"
            fill="#3F3D56"
          />
          <path
            id="Path 681"
            d="M87.921 22.3156C86.9175 22.3173 85.9557 22.7171 85.2467 23.4272C84.5377 24.1373 84.1395 25.0998 84.1395 26.1033C84.1395 27.1068 84.5377 28.0693 85.2467 28.7794C85.9557 29.4896 86.9175 29.8893 87.921 29.891H164.755C165.759 29.8893 166.721 29.4896 167.43 28.7794C168.139 28.0693 168.537 27.1068 168.537 26.1033C168.537 25.0998 168.139 24.1373 167.43 23.4272C166.721 22.7171 165.759 22.3173 164.755 22.3156H87.921Z"
            fill="#3F3D56"
          />
          <path
            id="aborter"
            d="M126.339 93.0896C121.624 93.0896 117.014 91.6914 113.094 89.0718C109.173 86.4521 106.117 82.7288 104.313 78.3725C102.508 74.0162 102.036 69.2226 102.956 64.598C103.876 59.9733 106.146 55.7253 109.48 52.391C112.814 49.0568 117.062 46.7861 121.687 45.866C126.312 44.946 131.105 45.418 135.462 47.2223C139.818 49.0266 143.542 52.0821 146.161 56.0026C148.781 59.9231 150.18 64.5324 150.18 69.2476V69.2476C150.173 75.5685 147.659 81.6286 143.189 86.0983C138.72 90.5679 132.66 93.0823 126.339 93.0896V93.0896Z"
            fill="#FF6584"
            ref={aborter}
          />
          <path
            id="Path 680_2"
            d="M484.921 -7.62939e-06C483.917 -7.62939e-06 482.953 0.399074 482.243 1.1094C481.532 1.81972 481.133 2.7831 481.133 3.78765C481.133 4.7922 481.532 5.75561 482.243 6.46593C482.953 7.17626 483.917 7.57531 484.921 7.57531H561.755C562.76 7.57531 563.723 7.17626 564.434 6.46593C565.144 5.75561 565.543 4.7922 565.543 3.78765C565.543 2.7831 565.144 1.81972 564.434 1.1094C563.723 0.399074 562.76 -7.62939e-06 561.755 -7.62939e-06H484.921Z"
            fill="#3F3D56"
          />
          <path
            id="Path 681_2"
            d="M484.921 22.3156C483.918 22.3173 482.956 22.7171 482.247 23.4272C481.538 24.1373 481.139 25.0998 481.139 26.1033C481.139 27.1068 481.538 28.0693 482.247 28.7794C482.956 29.4896 483.918 29.8893 484.921 29.891H561.755C562.759 29.8893 563.721 29.4896 564.43 28.7794C565.139 28.0693 565.537 27.1068 565.537 26.1033C565.537 25.0998 565.139 24.1373 564.43 23.4272C563.721 22.7171 562.759 22.3173 561.755 22.3156H484.921Z"
            fill="#3F3D56"
          />
          <path
            id="launcher"
            d="M523.339 93.0896C518.624 93.0896 514.014 91.6914 510.094 89.0718C506.173 86.4521 503.117 82.7288 501.313 78.3725C499.508 74.0162 499.036 69.2226 499.956 64.598C500.876 59.9733 503.146 55.7253 506.48 52.391C509.814 49.0568 514.062 46.7861 518.687 45.866C523.312 44.946 528.105 45.418 532.462 47.2223C536.818 49.0266 540.542 52.0821 543.161 56.0026C545.781 59.9231 547.18 64.5324 547.18 69.2476V69.2476C547.173 75.5685 544.659 81.6286 540.189 86.0983C535.72 90.5679 529.66 93.0823 523.339 93.0896V93.0896Z"
            fill="#39FF14"
            ref={launcher}
          />
          <g id="alien1">
            <path
              id="righthand"
              d="M230.448 148.378C232.151 144.788 224.26 137.48 212.823 132.056C201.386 126.631 190.734 125.145 189.032 128.735C187.329 132.325 195.22 139.633 206.657 145.058C218.093 150.482 228.745 151.969 230.448 148.378Z"
              fill="#39FF14"
            />
            <path
              id="lefthand"
              d="M324.838 185.358C327.884 182.807 323.767 172.872 315.641 163.166C307.515 153.461 298.458 147.661 295.411 150.212C292.364 152.763 296.482 162.699 304.608 172.404C312.734 182.11 321.791 187.909 324.838 185.358Z"
              fill="#39FF14"
              ref={leftHand1}
            />
            <path
              id="Vector"
              d="M261.37 205.665C286.686 205.665 307.208 185.142 307.208 159.826C307.208 134.51 286.686 113.987 261.37 113.987C236.054 113.987 215.531 134.51 215.531 159.826C215.531 185.142 236.054 205.665 261.37 205.665Z"
              fill="#39FF14"
            />
            <path
              id="Vector_2"
              d="M280.771 195.801H266.846V220.751H280.771V195.801Z"
              fill="#39FF14"
            />
            <path
              id="Vector_3"
              d="M252.92 195.801H238.994V220.751H252.92V195.801Z"
              fill="#39FF14"
            />
            <path
              id="Vector_4"
              d="M269.167 225.393C275.576 225.393 280.771 223.444 280.771 221.041C280.771 218.637 275.576 216.689 269.167 216.689C262.757 216.689 257.562 218.637 257.562 221.041C257.562 223.444 262.757 225.393 269.167 225.393Z"
              fill="#39FF14"
            />
            <path
              id="Vector_5"
              d="M241.315 224.812C247.724 224.812 252.92 222.864 252.92 220.461C252.92 218.057 247.724 216.109 241.315 216.109C234.906 216.109 229.71 218.057 229.71 220.461C229.71 222.864 234.906 224.812 241.315 224.812Z"
              fill="#39FF14"
            />
            <path
              id="eyeball"
              d="M254.517 165.436C262.957 165.436 269.799 158.594 269.799 150.154C269.799 141.713 262.957 134.871 254.517 134.871C246.076 134.871 239.234 141.713 239.234 150.154C239.234 158.594 246.076 165.436 254.517 165.436Z"
              fill="white"
            />
            <path
              id="pupil"
              d="M248.235 149.77C251.049 149.77 253.33 147.489 253.33 144.676C253.33 141.862 251.049 139.582 248.235 139.582C245.422 139.582 243.141 141.862 243.141 144.676C243.141 147.489 245.422 149.77 248.235 149.77Z"
              fill="#3F3D56"
              ref={pupil1}
            />
            <path
              id="mouth"
              d="M264.104 181.994C264.585 184.652 263.992 187.392 262.454 189.612C260.917 191.832 258.56 193.351 255.903 193.835C253.246 194.318 250.506 193.727 248.284 192.191C246.063 190.655 244.542 188.3 244.056 185.644V185.644L244.053 185.624C243.05 180.087 247.331 178.128 252.868 177.125C258.405 176.123 263.101 176.457 264.104 181.994Z"
              fill="white"
              ref={mouth1}
            />
          </g>
          <g id="alien2">
            <path
              id="lefthand_2"
              d="M443.019 145.057C454.456 139.633 462.347 132.325 460.644 128.735C458.941 125.145 448.289 126.631 436.852 132.056C425.415 137.48 417.524 144.788 419.227 148.378C420.93 151.969 431.582 150.482 443.019 145.057Z"
              fill="#39FF14"
              ref={leftHand2}
            />
            <path
              id="righthand_2"
              d="M345.068 172.404C353.194 162.699 357.311 152.763 354.264 150.212C351.218 147.661 342.16 153.461 334.034 163.166C325.908 172.872 321.791 182.807 324.838 185.358C327.884 187.909 336.942 182.11 345.068 172.404Z"
              fill="#39FF14"
              ref={rightHand2}
            />
            <path
              id="Vector_6"
              d="M388.306 205.665C413.622 205.665 434.145 185.142 434.145 159.826C434.145 134.51 413.622 113.987 388.306 113.987C362.99 113.987 342.467 134.51 342.467 159.826C342.467 185.142 362.99 205.665 388.306 205.665Z"
              fill="#39FF14"
            />
            <path
              id="Vector_7"
              d="M382.83 195.801H368.904V220.751H382.83V195.801Z"
              fill="#39FF14"
            />
            <path
              id="Vector_8"
              d="M410.681 195.801H396.755V220.751H410.681V195.801Z"
              fill="#39FF14"
            />
            <path
              id="Vector_9"
              d="M380.509 225.393C386.918 225.393 392.114 223.444 392.114 221.041C392.114 218.637 386.918 216.689 380.509 216.689C374.1 216.689 368.904 218.637 368.904 221.041C368.904 223.444 374.1 225.393 380.509 225.393Z"
              fill="#39FF14"
            />
            <path
              id="Vector_10"
              d="M408.36 224.812C414.769 224.812 419.965 222.864 419.965 220.461C419.965 218.057 414.769 216.109 408.36 216.109C401.951 216.109 396.755 218.057 396.755 220.461C396.755 222.864 401.951 224.812 408.36 224.812Z"
              fill="#39FF14"
            />
            <path
              id="Vector_11"
              d="M402.699 102.206C398.606 85.7219 380.539 76.0217 362.344 80.5394C344.15 85.0572 332.719 102.082 336.812 118.566C340.905 135.049 354.484 135.103 372.679 130.585C390.873 126.067 406.792 118.689 402.699 102.206Z"
              fill="#39FF14"
            />
            <path
              id="Vector_12"
              d="M395.159 165.436C403.599 165.436 410.441 158.594 410.441 150.154C410.441 141.713 403.599 134.871 395.159 134.871C386.718 134.871 379.876 141.713 379.876 150.154C379.876 158.594 386.718 165.436 395.159 165.436Z"
              fill="white"
            />
            <path
              id="pupil_2"
              d="M401.44 149.77C404.253 149.77 406.534 147.489 406.534 144.676C406.534 141.862 404.253 139.582 401.44 139.582C398.626 139.582 396.346 141.862 396.346 144.676C396.346 147.489 398.626 149.77 401.44 149.77Z"
              fill="#3F3D56"
              ref={pupil2}
            />
            <path
              id="mouth_2"
              d="M385.572 181.994C385.09 184.652 385.683 187.392 387.221 189.612C388.759 191.832 391.115 193.351 393.772 193.835C396.429 194.318 399.17 193.727 401.391 192.191C403.613 190.655 405.133 188.3 405.619 185.644V185.644L405.623 185.624C406.625 180.087 402.344 178.128 396.807 177.125C391.27 176.123 386.574 176.457 385.572 181.994Z"
              fill="white"
              ref={mouth2}
            />
          </g>
          <path
            id="Vector_13"
            d="M648.485 226.13H1.19067C0.875482 226.129 0.573504 226.003 0.350952 225.78C0.1284 225.557 0.00344849 225.254 0.00344849 224.939C0.00344849 224.624 0.1284 224.322 0.350952 224.098C0.573504 223.875 0.875482 223.749 1.19067 223.748H648.485C648.8 223.748 649.103 223.874 649.327 224.097C649.55 224.32 649.675 224.623 649.675 224.939C649.675 225.255 649.55 225.558 649.327 225.781C649.103 226.004 648.8 226.13 648.485 226.13V226.13Z"
            fill="#3F3D56"
          />
        </g>
        <defs>
          <clipPath id="clip0_0_1">
            <rect width="649.675" height="226.13" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}

export default Decide;
